import axios from "axios";
const endpoint =
  process.env.VUE_APP_BASE_API + "/api/master/selling/GeneralSurcharges";

export default {
  async getAll(masterClassId, type, serviceType) {
    const dynamicURL = serviceType === 1 ? "airport-transfer" : "rental";
    return await axios
      .get(endpoint + `/${dynamicURL}/${masterClassId}?type=${type}`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async delete(id) {
    return await axios
      .delete(endpoint + `/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/master/sellingTariff/sellingTariffGeneralSurchargeService.js